const routes = [
    {
        path: "/purchase-order/request-form",
        component: () => import("../pages/InstructorForm.vue"),
        meta: {
            isAuthenticated: true,
            isStaff: true,
            permission: 'purchaseorderform_store',
        },
    },
    {
        path: "/purchase-order/:id",
        component: () => import("../pages/Detail.vue"),
        meta: {
            isAuthenticated: true,
            permission: 'purchaseorderform_show',
        },
    },
    {
        path: "/purchase-orders",
        component: () => import("../pages/Index.vue"),
        meta: {
            isAuthenticated: true,
            permission: 'purchaseorderform_index',
        },
    },
];

export default routes;
